import React from "react";
import Field from "@/components/post-ad/Field";
import DuplicateWarningCard from "@/components/post-ad/DuplicateWarningCard";
import { POST } from "@/constants/testIds";

/**
 * Title + description pair with an inline soft-warning card between them
 * for suspected duplicates (§2.1). The card is a passive nudge — posting
 * is never blocked.
 */
export default function BasicsSection({ form, set, dupMatches, prefilledKeys = {}, clearPrefill = () => {} }) {
  return (
    <>
      <Field label="Title *" prefilled={!!prefilledKeys.title}>
        <input
          data-testid={POST.title}
          value={form.title}
          onChange={(e) => {
            set({ title: e.target.value });
            clearPrefill(["title"]);
          }}
          className="input"
          required
          maxLength={120}
        />
      </Field>
      <DuplicateWarningCard matches={dupMatches} />
      <Field label="Description *">
        <textarea
          data-testid={POST.description}
          value={form.description}
          onChange={(e) => set({ description: e.target.value })}
          className="input min-h-32"
          required
        />
      </Field>
    </>
  );
}
